import { versionedComponent } from '@edreamsodigeo/frontend-core';
export const NEW_INVOICE_EXPERIENCE = 'INF_INF912';
export const C4AR_AS_VOUCHER = 'GUARD_GUARD844';
export const C4AR_GDS_NON_PRIME_TO_OFFLINE_REDEMPTION = 'GUARD_GUARD1131';
export const CNX_REFACTOR = 'INF_INF1518';
export const REMOVE_ESCALATION_LINKS_LC_FLOWS = 'CAT_CAT3313';
export const SPLIT_MMB_FROM_TRIPDETAILS = 'FSC_SUMO5647';
export const AVOID_CNX_NON_REFUNDABLE = 'CAT_CAT3481';
export const SHOW_VIRTUAL_CREDENTIALS = 'CAT_CAT3752';
export const SHOW_PAX_SELECTOR = 'CAT_CAT3840';
export const createNEW_INVOICE_EXPERIENCE = versionedComponent(NEW_INVOICE_EXPERIENCE);
export const createC4AR_AS_VOUCHER = versionedComponent(C4AR_AS_VOUCHER);
export const createC4AR_GDS_NON_PRIME_TO_OFFLINE_REDEMPTION = versionedComponent(C4AR_GDS_NON_PRIME_TO_OFFLINE_REDEMPTION);
export const createCNX_REFACTOR = versionedComponent(CNX_REFACTOR);
export const createREMOVE_ESCALATION_LINKS_LC_FLOWS = versionedComponent(REMOVE_ESCALATION_LINKS_LC_FLOWS);
export const createSPLIT_MMB_FROM_TRIPDETAILS = versionedComponent(SPLIT_MMB_FROM_TRIPDETAILS);
export const createAVOID_CNX_NON_REFUNDABLE = versionedComponent(AVOID_CNX_NON_REFUNDABLE);
export const createSHOW_VIRTUAL_CREDENTIALS = versionedComponent(SHOW_VIRTUAL_CREDENTIALS);
export const createSHOW_PAX_SELECTOR = versionedComponent(SHOW_PAX_SELECTOR);
export const aliases = [NEW_INVOICE_EXPERIENCE, C4AR_AS_VOUCHER, C4AR_GDS_NON_PRIME_TO_OFFLINE_REDEMPTION, SHOW_VIRTUAL_CREDENTIALS, CNX_REFACTOR, REMOVE_ESCALATION_LINKS_LC_FLOWS, SPLIT_MMB_FROM_TRIPDETAILS, AVOID_CNX_NON_REFUNDABLE, SHOW_PAX_SELECTOR];